module.exports = __webpack_public_path__ + "img/saddle-cloths-14.11126ba5.svg";